// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"426":"8e254b0e","519":"3fc5aaad"}[chunkId] + ".chunk.css";
};